// src/lib/analytics.ts
import posthog from "posthog-js";

let initialized = false;

export function initPostHog(): void {
  if (initialized) return;

  const key = process.env.NEXT_PUBLIC_POSTHOG_KEY;
  if (!key) return;

  posthog.init(key, {
    api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST || "https://us.i.posthog.com",
    autocapture: false,
    capture_pageview: false,
    capture_pageleave: false,
    disable_session_recording: true,
    persistence: "localStorage",
    loaded: (ph) => {
      if (process.env.NODE_ENV === "development") ph.debug();
    },
  });

  initialized = true;
}

function capture(event: string, properties?: Record<string, unknown>): void {
  if (!initialized) return;
  posthog.capture(event, properties);
}

// --- Eventos de registro ---

export function trackUserRegistered(email: string): void {
  capture("user_registered", { email });
}

export function trackEmailVerified(email: string): void {
  capture("email_verified", { email });
}

// --- Eventos de welcome ---

export function trackWelcomeViewed(): void {
  capture("welcome_viewed");
}

export function trackWelcomeCtaClicked(): void {
  capture("welcome_cta_clicked");
}

// --- Eventos del wizard ---

export function trackWizardStarted(): void {
  capture("wizard_started");
}

export function trackWizardStepCompleted(step: 1 | 2 | 3 | 4): void {
  capture(`wizard_step_${step}_completed`);
}

// --- Eventos de generación ---

export function trackPresetGenerationStarted(props: {
  modeler: string;
  song: string;
  artist: string;
}): void {
  capture("preset_generation_started", props);
}

export function trackPresetGenerationCompleted(props: {
  presetId: string;
}): void {
  capture("preset_generation_completed", props);
}

export function trackPresetGenerationFailed(props: {
  error: string;
}): void {
  capture("preset_generation_failed", props);
}

// --- Eventos de preset ---

export function trackPresetViewed(props: {
  presetId: string;
  modeler: string;
}): void {
  capture("preset_viewed", props);
}

export function trackPresetIterated(props: {
  presetId: string;
  version: number;
}): void {
  capture("preset_iterated", props);
}

export function trackPresetRated(props: {
  presetId: string;
  rating: number;
}): void {
  capture("preset_rated", props);
}

// --- Identificación ---

export function identifyUser(
  userId: string,
  traits: { email: string; name: string }
): void {
  if (!initialized) return;
  posthog.identify(userId, traits);
}

export function resetUser(): void {
  if (!initialized) return;
  posthog.reset();
}
